import { render } from "./CollectionTopicSelector.vue?vue&type=template&id=b719b1a8"
import script from "./CollectionTopicSelector.vue?vue&type=script&lang=js"
export * from "./CollectionTopicSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__